import React from 'react'
import { MuiGrid } from '../../../ui/MaterialUIComponents';
import IndividualTimeTableForClass from './IndividualTimeTableForClass'
import IndividualTimeTableForTeacher from './IndividualTimeTableForTeacher'
import IndividualTimeTableForRoom from './IndividualTimeTableForRoom'
import '../../../ui/scrollbarForLog.css'
import theme from '../../../../assests/theme';
export default function IndividualTimeTableSchedule(props) {
      function setTitleTextStyleBasedOnLicense(index1, index) {
        if (index1 >= index) {
            return theme.titleTextStyleForTT
        }
        else {
            return theme.titleTextStyleForTTBlur
        }
    }
    function setSummaryTextStyleBasedOnLicense(index1, index) {
        if (index1 >= index) {
            return {}
        }
        else {
            return {filter: 'blur(2px)'}
        }
    }
    function setCellTextStyleBasedOnLicense(index1, index) {
        if (index1 >= index) {
            return theme.cellTextStyleForTT
        }
        else {
            return theme.cellTextStyleForTTBlur
        }
    }
    function setCellLunchTextStyleBasedOnLicense(index1, index) {
        if (index1 >= index) {
            return theme.cellLunchTextStyleForTT
        }
        else {
            return theme.cellLunchTextStyleForTTBlur
        }

    }

    return (
        <MuiGrid container xs={12} style={{ height: '65vh', overflowY: 'auto', width: '100%' }} id='scrollStyleWithoutDisplay'>

            <MuiGrid container xs={11} >
                {props.timeTableType == 'forClass' ?
                    <IndividualTimeTableForClass {...props}
                        setCellLunchTextStyleBasedOnLicense={setCellLunchTextStyleBasedOnLicense}
                        setCellTextStyleBasedOnLicense={setCellTextStyleBasedOnLicense}
                        setTitleTextStyleBasedOnLicense={setTitleTextStyleBasedOnLicense}
                        setSummaryTextStyleBasedOnLicense={setSummaryTextStyleBasedOnLicense}
                        /> :
                    props.timeTableType == 'forTeacher' ?
                        <IndividualTimeTableForTeacher
                            {...props}
                            timeTableForTeacher={props.timeTableForTeacher}
                            availableTeachersList={props.availableTeachersList}
                            setCellLunchTextStyleBasedOnLicense={setCellLunchTextStyleBasedOnLicense}
                            setCellTextStyleBasedOnLicense={setCellTextStyleBasedOnLicense}
                            setTitleTextStyleBasedOnLicense={setTitleTextStyleBasedOnLicense}
                            setSummaryTextStyleBasedOnLicense={setSummaryTextStyleBasedOnLicense}
                        /> : <IndividualTimeTableForRoom
                            {...props}
                            roomsTimeTable={props.roomsTimeTable}
                            setCellLunchTextStyleBasedOnLicense={setCellLunchTextStyleBasedOnLicense}
                            setCellTextStyleBasedOnLicense={setCellTextStyleBasedOnLicense}
                            setTitleTextStyleBasedOnLicense={setTitleTextStyleBasedOnLicense}
                            setSummaryTextStyleBasedOnLicense={setSummaryTextStyleBasedOnLicense}
                        />}</MuiGrid></MuiGrid>
    )
}